import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  loadingPdf: false,
  errorMessage: null,
  base64String: null,
};

const apiUrl = 'api/generate-pdf';
export type GeneratePdfState = Readonly<typeof initialState>;

export const getPdfBase64String = createAsyncThunk('pdf/fetch_base64_string', async (id: string | number) => {
  const requestUrl = `${apiUrl}/maintenance-vehicles-custom/${id}`;
  return axios.get<any>(requestUrl);
});

const pdfSlice = createSlice({
  name: 'pdf',
  initialState,
  reducers: {
    clearBase64String(state) {
      state.base64String = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getPdfBase64String.fulfilled, (state, action) => {
        state.loadingPdf = false;
        state.base64String = action.payload.data;
      })
      .addCase(getPdfBase64String.pending, state => {
        state.loadingPdf = true;
        state.errorMessage = null;
      })
      .addCase(getPdfBase64String.rejected, (state, action) => {
        state.loadingPdf = false;
        state.errorMessage = null;
      });
  },
});

export const { clearBase64String } = pdfSlice.actions;

export default pdfSlice.reducer;
